import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["text"]
  static values = {
    strings: Array,
    typeSpeed: Number,
    eraseSpeed: Number,
    pauseDuration: Number
  }

  connect() {
    if (!this.hasTextTarget || !this.hasStringsValue) return

    this.currentIndex = 0
    this.typeSpd = this.hasTypeSpeedValue ? this.typeSpeedValue : 30
    this.eraseSpd = this.hasEraseSpeedValue ? this.eraseSpeedValue : 15
    this.pause = this.hasPauseDurationValue ? this.pauseDurationValue : 3000

    // Set up the text container
    this.textTarget.textContent = ""
    this.textNode = document.createTextNode("")
    this.textTarget.appendChild(this.textNode)

    this.cursor = document.createElement("span")
    this.cursor.className = "streaming-cursor"
    this.textTarget.appendChild(this.cursor)

    // Start typing the first string after a short delay
    setTimeout(() => this.typeString(), 500)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  typeString() {
    const str = this.stringsValue[this.currentIndex]
    let i = 0

    const type = () => {
      if (i < str.length) {
        this.textNode.textContent += str.charAt(i)
        i++
        this.timer = setTimeout(type, this.typeSpd)
      } else {
        // Pause, then erase
        this.timer = setTimeout(() => this.eraseString(), this.pause)
      }
    }

    type()
  }

  eraseString() {
    const currentText = this.textNode.textContent

    if (currentText.length > 0) {
      this.textNode.textContent = currentText.slice(0, -1)
      this.timer = setTimeout(() => this.eraseString(), this.eraseSpd)
    } else {
      // Move to next string
      this.currentIndex = (this.currentIndex + 1) % this.stringsValue.length
      this.timer = setTimeout(() => this.typeString(), 400)
    }
  }
}
